window.TickerNewsComponent = {

    init: async function () {
        if (__LOG_INFO__) AppLog.info('init: Starting initialization');
        this.articles = [];
        this.overlay = null;

        try {
            this.apiManager = await NewsProxyAPIManager.create();
            if (__LOG_INFO__) AppLog.info('init: NewsProxyAPIManager initialized successfully');
        } catch (error) {
            if (__LOG_ERROR__) AppLog.error('init: Failed to initialize MediastackAPIManager: ', error.message);
            return;
        }

        this.container = document.querySelector(this.data.containerSelector);
        if (!this.container) {
            console.warn(`ticker-news: Container ${this.data.containerSelector} not found`);
        }

        this.currentMode = 'market-summary';
        this.setupNewsFilters();

        this.activeWatchlistId = null; 

        this.onWatchlistDataLoaded = this.onWatchlistDataLoaded.bind(this);
        document.body.addEventListener('watchlist-data-loaded', this.onWatchlistDataLoaded);
        
        this.onAuthSessionChanged = this.onAuthSessionChanged.bind(this);
        document.addEventListener('auth:session-changed', this.onAuthSessionChanged);

        this.onWatchlistAuthChanged = this.onWatchlistAuthChanged.bind(this);
        document.addEventListener('watchlist:auth-changed', this.onWatchlistAuthChanged);
        
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.attributeName === 'class') {
                    const isWatchlistMode = document.body.classList.contains('watchlist-mode');
                    
                    if (isWatchlistMode && !this.wasInWatchlistMode) {
                         const State = window.WatchlistApp?.State;
                         if (State?.currentWatchlistId) {
                             this.activeWatchlistId = State.currentWatchlistId;
                         }
                         this.currentMode = 'watchlist-news';
                         this.syncFiltersUI('watchlist');
                         this.data.ticker = 'BUSINESS'; 
                         this.update({ticker: 'FORCE_UPDATE'});
                    } else if (!isWatchlistMode && this.wasInWatchlistMode) {
                        if (__LOG_INFO__) AppLog.info('Exited watchlist mode, reverting to ticker news');
                        this.currentMode = 'market-summary';
                        this.syncFiltersUI('general');
                        this.data.ticker = 'BUSINESS'; 
                        this.update({ticker: 'FORCE_UPDATE'}); 
                    }
                    this.wasInWatchlistMode = isWatchlistMode;
                }
            });
        });
        this.observer.observe(document.body, { attributes: true });


        try {
             if (document.body.classList.contains('watchlist-mode')) {
                 const State = window.WatchlistApp?.State;
                 if (State?.currentUserId && State?.currentWatchlistId) {
                     this.syncFiltersUI('watchlist');
                     this.currentMode = 'watchlist-news';
                     this.renderWatchlistNews();
                 }
             } else if (this.data.ticker && this.data.ticker.toUpperCase() !== 'BUSINESS') {
                this.currentMode = 'ticker-news';
                this.renderTickerNews(this.data.ticker);
             } else {
                this.currentMode = 'market-summary';
                this.renderMarketSummary();
             }

        } catch (error) {
            if (__LOG_ERROR__) AppLog.error('init: Failed to fetch articles:', error.message);
            this.showError(this.news, 'Failed to fetch articles: ' + error.message);
        }

        if (this.container) {
            const backToListButtonHTML = this.container.querySelector('.news-mode .title-block .img-wrapper');
            if (backToListButtonHTML) {
                backToListButtonHTML.addEventListener('click', () => {
                    if (this._detailBackFn) {
                        const fn = this._detailBackFn;
                        this._detailBackFn = null;
                        fn();
                        return;
                    }
                    this.container.classList.remove('news-open');
                    const newsMode = this.container.querySelector('.news-mode');
                    if (newsMode) newsMode.classList.remove('narrative-mode');
                    const titleH3 = this.container.querySelector('.news-mode .title-block h3');
                    if (titleH3) titleH3.textContent = 'News';
                });
            }
        }

        this.newsScheduler = new window.AutoRefreshScheduler({
            name: 'TickerNews',
            onRefresh: () => {
                this.update({ticker: 'FORCE_UPDATE'});
            }
        });
        
        this.newsScheduler.start();
    },

    updateWatchlistBtnState: function(isLoggedIn) {
        if (!this.container) return;
        const watchlistBtn = this.container.querySelector('.view-btn[data-filter="watchlist-news"]');
        if (!watchlistBtn) return;
        if (isLoggedIn) {
            watchlistBtn.classList.remove('disabled');
        } else {
            watchlistBtn.classList.add('disabled');
        }
    },

    isPreIpoSymbol: function(symbol) {
        if (!this.lastNarrativeData?.tickers) return false;
        const cleanSym = String(symbol || '').toUpperCase().trim();
        return this.lastNarrativeData.tickers.some(t => t.possible_pre_ipo === true && String(t.symbol || '').toUpperCase().trim() === cleanSym);
    },

    cleanSourceName: function(source, url) {
        let name = source || '';
        const isGeneric = !name || 
            name.toLowerCase().includes('stocknewsapi') || 
            name.toLowerCase().includes('fmp_') || 
            name.toLowerCase().includes('mediastack') ||
            name.toLowerCase() === 'lulegacy';
            
        if (isGeneric && url) {
            try {
                const hostname = url.split('/')[2] || '';
                let host = hostname.toLowerCase();
                if (host.startsWith('www.')) host = host.slice(4);
                
                const domainMap = {
                    'marketwatch.com': 'MarketWatch',
                    'wsj.com': 'Wall Street Journal',
                    'seekingalpha.com': 'Seeking Alpha',
                    'bloomberg.com': 'Bloomberg',
                    'reuters.com': 'Reuters',
                    'cnbc.com': 'CNBC',
                    'globenewswire.com': 'GlobeNewswire',
                    'prnewswire.com': 'PR Newswire',
                    'businesswire.com': 'Business Wire',
                    'fool.com': 'The Motley Fool',
                    'investorplace.com': 'InvestorPlace',
                    'barrons.com': 'Barrons',
                    'thestreet.com': 'The Street',
                    'techcrunch.com': 'TechCrunch',
                    'foxbusiness.com': 'Fox Business',
                    'marketbeat.com': 'MarketBeat',
                    'investopedia.com': 'Investopedia',
                    'nytimes.com': 'New York Times',
                    'forbes.com': 'Forbes',
                    'businessinsider.com': 'Business Insider'
                };
                
                if (domainMap[host]) {
                    return domainMap[host];
                }
                
                const parts = host.split('.');
                if (parts.length >= 2) {
                    const domainName = parts[parts.length - 2];
                    return domainName.charAt(0).toUpperCase() + domainName.slice(1);
                }
                return host;
            } catch (e) {}
        }
        
        if (name === 'stocknewsapi_general') return 'General News';
        if (name.startsWith('fmp_')) return 'Financial News';
        if (name === 'mediastack_business') return 'Mediastack';
        
        return name || 'Unknown';
    },

    setupNewsFilters: function() {
        if (!this.container) return;
        const generalBtn = this.container.querySelector('.view-btn[data-filter="market-summary"]');
        const watchlistBtn = this.container.querySelector('.view-btn[data-filter="watchlist-news"]');
        
        if (!generalBtn || !watchlistBtn) return;

        let isLoggedIn = false;
        if (window.currentSession && window.currentSession.user && !window.currentSession.user.is_anonymous) {
            isLoggedIn = true;
        } else {
            try {
                const sessionStr = localStorage.getItem('auth_session');
                if (sessionStr) {
                    const sessionItem = JSON.parse(sessionStr);
                    if (sessionItem?.expiry && Date.now() < sessionItem.expiry) {
                        const user = sessionItem.value?.user;
                        if (user && !user.is_anonymous) isLoggedIn = true;
                    }
                }
            } catch (e) {}
        }
        this.updateWatchlistBtnState(isLoggedIn);

        generalBtn.addEventListener('click', () => {
             this.currentMode = 'market-summary';
             this.data.ticker = 'BUSINESS';
             this.syncFiltersUI('market-summary');
             this.renderMarketSummary();
             if (window.gtag) gtag('event', 'Desktop_LeftPanel_MarketSummary');
        });

        const headlinesBtn = this.container.querySelector('.view-btn[data-filter="business-headlines"]');
        if (headlinesBtn) {
            headlinesBtn.addEventListener('click', () => {
                this.currentMode = 'business-headlines';
                this.data.ticker = 'BUSINESS';
                this.syncFiltersUI('business-headlines');
                this.renderBusinessHeadlines();
                if (window.gtag) gtag('event', 'Desktop_LeftPanel_BusinessHeadlines');
            });
        }

        const trendingBtn = this.container.querySelector('.view-btn[data-filter="trending-stock"]');
        if (trendingBtn) {
            trendingBtn.addEventListener('click', () => {
                this.currentMode = 'trending-stock';
                this.data.ticker = 'BUSINESS';
                this.syncFiltersUI('trending-stock');
                this.renderTrendingStock();
                if (window.gtag) gtag('event', 'Desktop_LeftPanel_TrendingStock');
            });
        }

        watchlistBtn.addEventListener('click', async () => {
            const State = window.WatchlistApp?.State;
            const Manager = window.WatchlistApp?.Manager;
            
            if (window.consentGiven === false) {
                if (window.AuthUI && window.AuthUI.showMessage) {
                    window.AuthUI.showMessage('Login restricted. You cannot login until you accept the cookies');
                }
                return;
            }

            let isLoggedIn = false;
            if (window.currentSession && window.currentSession.user) {
                if (!window.currentSession.user.is_anonymous) {
                    isLoggedIn = true;
                }
            } else {
                try {
                    const sessionStr = localStorage.getItem('auth_session');
                    if (sessionStr) {
                        const sessionItem = JSON.parse(sessionStr);
                        if (sessionItem && sessionItem.expiry && Date.now() < sessionItem.expiry) {
                            const user = sessionItem.value?.user;
                            if (user && !user.is_anonymous) {
                                isLoggedIn = true;
                            }
                        }
                    }
                } catch (e) {
                    if (__LOG_ERROR__) AppLog.error('Error checking login status', e);
                }
            }

            if (!isLoggedIn) {
                 const message = 'Log in to access watchlist';
                 
                 if (window.WatchlistApp && window.WatchlistApp.Popup && window.WatchlistApp.Popup.showNotificationPopup) {
                    window.WatchlistApp.Popup.showNotificationPopup('Watchlist Access', message);
                } else {
                    alert(message);
                }
                return;
            }

            if (!State.allWatchlists || State.allWatchlists.length === 0) {
                 if (Manager && Manager.updateWatchlistState) {
                      if (__LOG_INFO__) AppLog.info('Loading watchlists for filter...');
                      await Manager.updateWatchlistState();
                 }
            }
            
            const allWatchlists = State?.allWatchlists || [];
            if (allWatchlists.length > 0) {
                 this.activeWatchlistId = allWatchlists[0].id;
                 if (__LOG_INFO__) AppLog.info(`Switched to Watchlist filter. Active Watchlist: ${this.activeWatchlistId} (${allWatchlists[0].name})`);
            } else {
                 this.activeWatchlistId = null; 
            }

             this.currentMode = 'watchlist-news';
             this.data.ticker = 'BUSINESS';
             this.syncFiltersUI('watchlist');
             this.renderWatchlistNews();

            if (window.gtag) gtag('event', 'Desktop_LeftPanel_WatchlistButton');
        });
    },

    renderBusinessHeadlines: async function(forceFetch = false) {
        if (!this.container) return;
        const newsListEl = this.container.querySelector('.news-list');
        const titleEl = this.container.querySelector('.preview-mode .title h3');

        if (titleEl) titleEl.textContent = 'Business Headlines';
        
        const isInitialLoad = !newsListEl || !newsListEl.children.length || newsListEl.querySelector('.news-error') || newsListEl.querySelector('.news-loading');
        if (isInitialLoad && newsListEl) newsListEl.innerHTML = '<p class="news-loading">Loading...</p>';

        let data = forceFetch ? null : this.lastNarrativeData;
        if (!data) {
            try {
                data = await this.apiManager.fetchNarrativeTickerMap();
                this.lastNarrativeData = data;
            } catch (e) {
                if (newsListEl) newsListEl.innerHTML = '<p class="news-error">Failed to load headlines.</p>';
                return;
            }
        }

        const articles = data?.articles || {};
        const lists = data?.lists || data?.rankings || {};
        let summaryIds = lists.summary_articles || [];

        if (!summaryIds.length && data?.lists?.market_narratives && Array.isArray(data.narratives)) {
            const seen = new Set();
            data.lists.market_narratives.slice(0, 6).forEach(nid => {
                const n = data.narratives.find(narr => narr.id === nid);
                if (n && n.article_ids) {
                    n.article_ids.forEach(aid => {
                        if (!seen.has(aid) && articles[aid]) {
                            seen.add(aid);
                            summaryIds.push(aid);
                        }
                    });
                }
            });
        }

        const narrativeSummaryByArticleId = {};
        if (Array.isArray(data?.narratives)) {
            data.narratives.forEach(n => {
                const nSummary = (n?.summary || '').trim();
                if (!nSummary || !Array.isArray(n?.article_ids)) return;
                n.article_ids.forEach(aid => {
                    if (!narrativeSummaryByArticleId[aid]) {
                        narrativeSummaryByArticleId[aid] = nSummary;
                    }
                });
            });
        }

        const sharedTooltip = this._initSourceTooltip();

        if (!newsListEl) return;

        summaryIds = summaryIds
            .filter(aid => !!articles[aid])
            .sort((a, b) => {
                const aTime = new Date(articles[a]?.published_at || 0).getTime() || 0;
                const bTime = new Date(articles[b]?.published_at || 0).getTime() || 0;
                return bTime - aTime;
            });
        
        const scrollPos = newsListEl.scrollTop;
        newsListEl.innerHTML = '';

        summaryIds.forEach(aid => {
            const a = articles[aid];
            if (!a) return;

            let dateStr = '';
            if (a.published_at) {
                try {
                    const d = new Date(a.published_at);
                    dateStr = d.toLocaleString('en-US', { month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });
                } catch(e) {}
            }

            const rawSentiment = (a.sentiment || '').toLowerCase();
            const sentimentClass = rawSentiment === 'positive' ? 'bullish'
                : rawSentiment === 'negative' ? 'bearish'
                : (rawSentiment === 'neutral' || rawSentiment === 'mixed') ? rawSentiment
                : 'neutral';
            const sentimentLabel = sentimentClass.charAt(0).toUpperCase() + sentimentClass.slice(1);

            const card = document.createElement('div');
            card.className = 'headline-card';
            card.innerHTML = `
                <div class="source-card-header">
                    <span class="source-name">${this.cleanSourceName(a.source, a.url)}</span>
                    <span class="source-date">${dateStr}</span>
                </div>
                <div class="source-title headline-title">${(a.title || '').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div>
                <div class="headline-footer">
                    <span class="sentiment-badge ${sentimentClass}">${sentimentLabel}</span>
                    <a class="source-open-btn" href="${(a.url || '#').replace(/"/g,'%22')}" target="_blank" rel="noopener noreferrer">Open ↗</a>
                </div>
            `;

            const tooltipText = (a.text || '').trim();
            if (tooltipText) this._attachCardTooltip(card, tooltipText, sharedTooltip);

            newsListEl.appendChild(card);
        });
        newsListEl.scrollTop = scrollPos;
    },

    renderWatchlistNews: async function(forceFetch = false) {
        if (!this.container) return;
        const newsListEl = this.container.querySelector('.news-list');
        const titleEl = this.container.querySelector('.preview-mode .title h3');

        const isInitialLoad = !newsListEl || !newsListEl.children.length || newsListEl.querySelector('.news-error') || newsListEl.querySelector('.news-loading');
        if (isInitialLoad && newsListEl) newsListEl.innerHTML = '<p class="news-loading">Loading...</p>';

        const State = window.WatchlistApp?.State;
        let userId = State?.currentUserId;
        if (!userId) {
            try {
                const sessionStr = localStorage.getItem('auth_session');
                if (sessionStr) {
                    const sessionItem = JSON.parse(sessionStr);
                    userId = sessionItem.value?.user?.id || sessionItem.value?.user?.user_id;
                }
            } catch(e) {}
        }
        const watchlistId = this.activeWatchlistId || State?.currentWatchlistId;

        if (!userId || !watchlistId) {
            if (newsListEl) newsListEl.innerHTML = '<p class="news-loading">Please log in to view watchlist news.</p>';
            return;
        }

        const allWatchlists = State?.allWatchlists || [];
        const currentWatchlist = allWatchlists.find(w => w.id === watchlistId);
        const watchlistName = currentWatchlist ? currentWatchlist.name : 'Watchlist';
        if (titleEl) titleEl.textContent = watchlistName + ' News';

        let articles;
        try {
            articles = await this.apiManager.getWatchlistNews(userId, watchlistId);
        } catch(e) {
            if (newsListEl) newsListEl.innerHTML = '<p class="news-error">Failed to load watchlist news.</p>';
            return;
        }

        if (!newsListEl) return;
        if (!articles || articles.length === 0) {
            newsListEl.innerHTML = '<p class="news-error">No articles found.</p>';
            return;
        }

        const priceMap = NewsProxyAPIManager.buildTickerPriceMap(this.lastNarrativeData);
        const sharedTooltip = this._initSourceTooltip();
        
        const scrollPos = newsListEl.scrollTop;
        newsListEl.innerHTML = '';

        articles.forEach(article => {
            let dateStr = '';
            if (article.publishedDate) {
                try {
                    const d = new Date(article.publishedDate);
                    dateStr = d.toLocaleString('en-US', { month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });
                } catch(e) {}
            }

            const tickerPillsHTML = (article.tickers || []).slice(0, 3).map(sym => {
                if (this.isPreIpoSymbol(sym)) {
                    return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}<span class="pre-ipo-tag" style="color: #888; font-size: 11px; font-weight: bold; margin-left: 4px;">Pre-IPO</span></span>`;
                }
                const entry = priceMap.get(sym.toUpperCase());
                const chgPct = entry?.changePct ?? null;
                if (chgPct === null) return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}</span>`;
                const cls = chgPct >= 0 ? 'positive' : 'negative';
                const sign = chgPct >= 0 ? '+' : '';
                return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}<span class="asset-price-change ${cls}">${sign}${chgPct.toFixed(2)}%</span></span>`;
            }).join('');

            const card = document.createElement('div');
            card.className = 'watchlist-card';
            card.innerHTML = `
                <div class="source-card-header">
                    <span class="source-name">${article.publisher || 'Unknown'}</span>
                    <span class="source-date">${dateStr}</span>
                </div>
                <div class="watchlist-card-title">${(article.title || '').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div>
                <div class="watchlist-card-footer">
                    <div class="watchlist-card-tickers">${tickerPillsHTML}</div>
                    <a class="source-open-btn" href="${(article.url || '#').replace(/"/g,'%22')}" target="_blank" rel="noopener noreferrer">Open ↗</a>
                </div>
            `;

            card.querySelectorAll('.asset-pill--clickable[data-symbol]').forEach(pill => {
                pill.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this._detailBackFn = () => this.renderWatchlistNews(false);
                    this.openTickerFromPill(pill.dataset.symbol);
                });
            });

            const tooltipText = (article.description || '').trim();
            if (tooltipText) this._attachCardTooltip(card, tooltipText, sharedTooltip);

            newsListEl.appendChild(card);
        });
        newsListEl.scrollTop = scrollPos;
    },

    renderTrendingStock: async function(forceFetch = false) {
        if (!this.container) return;
        const newsListEl = this.container.querySelector('.news-list');
        const titleEl = this.container.querySelector('.preview-mode .title h3');

        if (titleEl) titleEl.textContent = 'Trending Stock';
        
        const isInitialLoad = !newsListEl || !newsListEl.children.length || newsListEl.querySelector('.news-error') || newsListEl.querySelector('.news-loading');
        if (isInitialLoad && newsListEl) newsListEl.innerHTML = '<p class="news-loading">Loading...</p>';

        let data = forceFetch ? null : this.lastNarrativeData;
        if (!data) {
            try {
                data = await this.apiManager.fetchNarrativeTickerMap();
                this.lastNarrativeData = data;
            } catch (e) {
                if (newsListEl) newsListEl.innerHTML = '<p class="news-error">Failed to load.</p>';
                return;
            }
        }

        const articles = data?.articles || {};
        const tickers = data?.tickers || [];
        const narratives = data?.narratives || [];
        const lists = data?.lists || data?.rankings || {};
        const trendingRefs = lists.trending_tickers || [];

        const tickerMap = {};
        tickers.forEach(t => { if (t?.id) tickerMap[t.id] = t; });

        const narrativeBySym = {};
        narratives.forEach(n => {
            const syms = [...(n.tickers || []), ...(n.affected_assets || [])];
            syms.forEach(sym => {
                if (!narrativeBySym[sym]) narrativeBySym[sym] = n;
            });
        });

        const getTickerDesc = (ticker) => {
            for (const sym of (ticker.grouped_tickers || [ticker.symbol])) {
                if (narrativeBySym[sym]) return narrativeBySym[sym].summary;
            }
            for (const aid of (ticker.article_ids || []).slice(0, 5)) {
                const text = articles[aid]?.text;
                if (text && text.length > 40) return text;
            }
            return '';
        };

        if (!newsListEl) return;
        const scrollPos = newsListEl.scrollTop;
        newsListEl.innerHTML = '';

        const trendingTickerItems = trendingRefs
            .map(ref => tickerMap[ref])
            .filter(Boolean);

        trendingTickerItems.sort((a, b) => {
            return (a.rank || Infinity) - (b.rank || Infinity);
        });

        trendingTickerItems.splice(20);


        const priceMap = NewsProxyAPIManager.buildTickerPriceMap(data);

        trendingTickerItems.forEach(ticker => {

            const syms = ticker.grouped_tickers || [ticker.symbol];
            const symbolDisplay = syms.length <= 3
                ? syms.join(' + ')
                : `${syms.slice(0, 2).join(' + ')} +${syms.length - 2}`;
            const description = getTickerDesc(ticker);

            const tickerPillsHTML = syms.slice(0, 3).map(rawSym => {
                const sym = String(rawSym || '').toUpperCase();
                if (!sym) return '';

                if (this.isPreIpoSymbol(sym)) {
                    return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}<span class="pre-ipo-tag" style="color: #888; font-size: 11px; font-weight: bold; margin-left: 4px;">Pre-IPO</span></span>`;
                }

                const chgPctRaw = priceMap.get(sym)?.changePct;
                const chgPct = (chgPctRaw !== null && chgPctRaw !== undefined) ? chgPctRaw : null;

                if (chgPct === null) {
                    return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}</span>`;
                }

                const cls = chgPct >= 0 ? 'positive' : 'negative';
                const sign = chgPct >= 0 ? '+' : '';
                return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}<span class="asset-price-change ${cls}">${sign}${chgPct.toFixed(2)}%</span></span>`;
            }).join('');

            const name = (ticker.group_label || ticker.name || ticker.symbol)
                .replace(/</g, '&lt;').replace(/>/g, '&gt;');

            const card = document.createElement('div');
            card.className = 'trending-ticker-card';
            card.innerHTML = `
                <div class="trending-ticker-name">${name} <span class="trending-ticker-symbol">(${symbolDisplay})</span></div>
                ${description ? `<div class="trending-ticker-summary">${description.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div>` : ''}
                ${tickerPillsHTML ? `<div class="trending-ticker-pills">${tickerPillsHTML}</div>` : ''}
                <div class="trending-ticker-footer">
                    <span class="trending-article-count">${ticker.article_count || 0} articles</span>
                    <button class="details-btn">Details →</button>
                </div>
            `;

            card.querySelector('.details-btn').addEventListener('click', () => {
                this.openTickerDetail(ticker, data);
            });
            card.querySelectorAll('.asset-pill--clickable[data-symbol]').forEach(pill => {
                pill.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this._detailBackFn = () => this.renderTrendingStock(false);
                    this.openTickerFromPill(pill.dataset.symbol);
                });
            });

            newsListEl.appendChild(card);
        });
        newsListEl.scrollTop = scrollPos;
    },

    renderMarketSummary: async function(forceFetch = false) {
        if (!this.container) return;
        const newsListEl = this.container.querySelector('.news-list');
        const titleEl = this.container.querySelector('.preview-mode .title h3');

        if (titleEl) titleEl.textContent = 'Market Summary';
        
        const isInitialLoad = !newsListEl || !newsListEl.children.length || newsListEl.querySelector('.news-error') || newsListEl.querySelector('.news-loading');
        if (isInitialLoad && newsListEl) newsListEl.innerHTML = '<p class="news-loading">Loading...</p>';

        let data = forceFetch ? null : this.lastNarrativeData;
        if (!data) {
            try {
                data = await this.apiManager.fetchNarrativeTickerMap();
                this.lastNarrativeData = data;
            } catch (e) {
                if (newsListEl) newsListEl.innerHTML = '<p class="news-error">Failed to load market summary.</p>';
                return;
            }
        }

        if (!data || !Array.isArray(data.narratives)) {
            if (newsListEl) newsListEl.innerHTML = '<p class="news-error">No data available.</p>';
            return;
        }

        this.lastNarrativeData = data;
        
        let narratives = data.narratives;
        const lists = data.lists || data.rankings || {};
        if (Array.isArray(lists.market_narratives)) {
            const map = {};
            data.narratives.forEach(n => { if (n.id) map[n.id] = n; });
            narratives = lists.market_narratives.map(id => map[id]).filter(Boolean);
        }

        narratives.sort((a, b) => {
            return (a.rank || Infinity) - (b.rank || Infinity);
        });

        let html = '';
        narratives.forEach(n => {
            const dir = (n.direction || 'neutral').toLowerCase();
            const dirLabel = dir.charAt(0).toUpperCase() + dir.slice(1);
            const count = n.article_count || 0;
            html += `<div class="news-item narrative-item" data-narrative-id="${n.id}">
                <div class="narrative-title">${n.title}</div>
                <div class="narrative-footer">
                    <span class="sentiment-badge ${dir}">${dirLabel}</span>
                    <span class="source-count">${count} source${count !== 1 ? 's' : ''}</span>
                    <button class="details-btn">Details →</button>
                </div>
            </div>`;
        });

        if (newsListEl) {
            const sharedTooltip = this._initSourceTooltip();
            const scrollPos = newsListEl.scrollTop;
            newsListEl.innerHTML = html;
            newsListEl.querySelectorAll('.narrative-item').forEach(item => {
                const btn = item.querySelector('.details-btn');
                const nid = item.dataset.narrativeId;
                const narrative = narratives.find(n => n.id === nid);
                if (btn && narrative) {
                    btn.addEventListener('click', () => this.openNarrativeDetail(narrative));
                }
                const tooltipText = (narrative?.summary || '').trim();
                if (tooltipText) this._attachCardTooltip(item, tooltipText, sharedTooltip);
            });
            newsListEl.scrollTop = scrollPos;
        }
    },

    openNarrativeDetail: async function(narrative) {
        if (window._newsGraphInstance && typeof window._newsGraphInstance.selectNodeById === 'function') {
            window._newsGraphInstance.selectNodeById(narrative.id, false);
        }

        if (window.NewsGraph && window.NewsGraph.updateOverviewPanel) {
            const data = this.lastNarrativeData;
            if (data) window.NewsGraph.updateOverviewPanel(narrative, data);
        }

        if (!this.container) return;
        const leftNewsBlock = this.container;
        const newsMode = this.container.querySelector('.news-mode');
        if (!newsMode) return;

        const dir = (narrative.direction || 'neutral').toLowerCase();
        const dirLabel = dir.charAt(0).toUpperCase() + dir.slice(1);
        const count = narrative.article_count || 0;

        const titleH3 = newsMode.querySelector('.title-block h3');
        if (titleH3) {
            titleH3.innerHTML = `<span class="detail-type-label">Market News Detail</span>${narrative.title}`;
        }

        const assets = [...(narrative.tickers || []), ...(narrative.affected_assets || [])];
        const priceMap = NewsProxyAPIManager.buildTickerPriceMap(this.lastNarrativeData);
        const assetsHTML = assets.length
            ? `<div class="detail-assets">${assets.slice(0, 3).map(a => {
                if (this.isPreIpoSymbol(a)) {
                    return `<span class="asset-pill asset-pill--clickable" data-symbol="${a}">${a}<span class="pre-ipo-tag" style="color: #888; font-size: 11px; font-weight: bold; margin-left: 4px;">Pre-IPO</span></span>`;
                }
                const entry = priceMap.get(a.toUpperCase());
                const chgPct = entry?.changePct ?? null;
                const price  = entry?.price  ?? null;
                let changeHTML = '';
                if (chgPct !== null) {
                    const chgDollar = (price !== null && price > 0)
                        ? price - (price / (1 + chgPct / 100))
                        : null;
                    const positive = chgPct >= 0;
                    const cls = positive ? 'positive' : 'negative';
                    const sign = positive ? '+' : '';
                    const pctFmt = `${sign}${chgPct.toFixed(2)}%`;
                    if (chgDollar !== null) {
                        const dollarFmt = `${sign}$${Math.abs(chgDollar).toFixed(2)}`;
                        changeHTML = `<span class="asset-price-change ${cls}">${dollarFmt} (${pctFmt})</span>`;
                    } else {
                        changeHTML = `<span class="asset-price-change ${cls}">${pctFmt}</span>`;
                    }
                }
                return `<span class="asset-pill asset-pill--clickable" data-symbol="${a}">${a}${changeHTML}</span>`;
            }).join('')}</div>`
            : '';

        const detailContent = newsMode.querySelector('.narrative-detail-content');
        if (detailContent) {
            const relTopics = this._pendingRelatedTopics;
            this._pendingRelatedTopics = null;
            let relatedTopicsHTML = '';
            if (relTopics && relTopics.entries && relTopics.entries.length > 0) {
                const pillsHTML = relTopics.entries.slice(0, 6).map(({ item, isTicker, rel }) => {
                    const relBadge = rel ? `<span class="rel-badge">${rel}</span>` : '';
                    if (isTicker) {
                        const sym = item.symbol || item.id;
                        const name = item.name || '';
                        let title = name ? `${sym} - ${name}` : sym;
                        title = title.replace(/</g,'&lt;').replace(/>/g,'&gt;');
                        return `<button type="button" data-ticker-id="${item.id}" class="news-pill" style="cursor:pointer; text-align:left;">${relBadge}${title}</button>`;
                    } else {
                        const title = (item.short_label || item.title || item.label || item.id).replace(/</g,'&lt;').replace(/>/g,'&gt;');
                        return `<button type="button" data-narrative-id="${item.id}" class="news-pill" style="cursor:pointer; text-align:left;">${relBadge}${title}</button>`;
                    }
                }).join('');
                relatedTopicsHTML = `<div class="detail-section">
                    <h4 class="detail-section-title">Related Topics</h4>
                    <div class="news-graph-news-list">${pillsHTML}</div>
                </div>`;
            }

            detailContent.innerHTML = `
                <div class="detail-badges">
                    <span class="sentiment-badge ${dir}">${dirLabel}</span>
                    ${narrative.freshness && narrative.freshness.status === 'inflection' ? `<span class="sentiment-badge inflection" style="color: #ff9f00; border-color: #ff9f00;">Inflection</span>` : ''}
                    <span class="source-count">${count} source${count !== 1 ? 's' : ''}</span>
                </div>
                ${assetsHTML}
                <div class="detail-section">
                    <h4 class="detail-section-title">Summary</h4>
                    <div class="detail-summary-card">${(narrative.summary || '').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div>
                </div>
                ${relatedTopicsHTML}
            `;

            detailContent.querySelectorAll('.asset-pill--clickable[data-symbol]').forEach(pill => {
                pill.addEventListener('click', () => {
                    this._detailBackFn = () => this.openNarrativeDetail(narrative);
                    this.openTickerFromPill(pill.dataset.symbol);
                });
            });

            if (relTopics) {
                detailContent.querySelectorAll('.news-pill[data-narrative-id]').forEach(btn => {
                    const nid = btn.getAttribute('data-narrative-id');
                    const n = (relTopics.narrativeMap || {})[nid];
                    if (n) btn.addEventListener('click', () => {
                        const d = relTopics.data || this.lastNarrativeData;
                        if (typeof _buildRelatedTopicsData === 'function') {
                            this._pendingRelatedTopics = _buildRelatedTopicsData(n, d);
                        }
                        this.openNarrativeDetail(n);
                    });
                });
                detailContent.querySelectorAll('.news-pill[data-ticker-id]').forEach(btn => {
                    const tid = btn.getAttribute('data-ticker-id');
                    const t = (relTopics.tickerMap || {})[tid];
                    if (t) btn.addEventListener('click', () => {
                        const d = relTopics.data || this.lastNarrativeData;
                        if (typeof _buildRelatedTopicsData === 'function') {
                            this._pendingRelatedTopics = _buildRelatedTopicsData(t, d);
                        }
                        this.openTickerDetail(t, d);
                    });
                });
            }
        }

        newsMode.classList.add('narrative-mode');
        leftNewsBlock.classList.add('news-open');
    },

    openTickerDetail: async function(ticker, data) {
        const syms = ticker.grouped_tickers || [ticker.symbol];
        const primarySymbol = String((syms[0] || ticker.symbol || '')).toUpperCase();

        const description = ticker.summary || '';
        const hasArticles = !!(ticker.article_ids && ticker.article_ids.length > 0);
        const hasSummary  = !!description;

        if (!hasArticles && !hasSummary) return;

        if (window._newsGraphInstance && typeof window._newsGraphInstance.selectNodeById === 'function') {
            const isGroup = ticker.is_group || ticker.type === 'ticker_group';
            const highlightId = isGroup ? (ticker.symbol || ticker.id) : primarySymbol;
            window._newsGraphInstance.selectNodeById(highlightId, false);
        }

        if (window.NewsGraph && window.NewsGraph.updateOverviewPanel && data) {
            window.NewsGraph.updateOverviewPanel(hasArticles ? ticker : null, data);
        }

        if (!this.container) return;
        const leftNewsBlock = this.container;
        const newsMode = this.container.querySelector('.news-mode');
        if (!newsMode) return;

        const name = (ticker.group_label || ticker.name || ticker.symbol)
            .replace(/</g, '&lt;').replace(/>/g, '&gt;');

        const titleH3 = newsMode.querySelector('.title-block h3');
        if (titleH3) {
            titleH3.innerHTML = `<span class="detail-type-label">Trending Stock &#8212; ${syms[0]}</span>${name}`;
        }

        const detailContent = newsMode.querySelector('.narrative-detail-content');
        if (detailContent) {
            const priceMap = NewsProxyAPIManager.buildTickerPriceMap(data);

            const memberPills = syms.map(rawSym => {
                const sym = String(rawSym || '').toUpperCase();
                if (!sym) return '';
                let changeHTML = '';
                if (this.isPreIpoSymbol(sym)) {
                    changeHTML = `<span class="ticker-price-change neutral"><span class="pre-ipo-tag" style="color:#888;font-size:11px;font-weight:bold;">Pre-IPO</span></span>`;
                } else {
                    const entry = priceMap.get(sym);
                    const chgPct = entry?.changePct ?? null;
                    const latestPrice = entry?.price ?? null;
                    const hasPct = chgPct !== null;
                    const cls = hasPct ? (chgPct >= 0 ? 'positive' : 'negative') : 'neutral';
                    const sign = hasPct && chgPct >= 0 ? '+' : '';
                    const pctText = hasPct ? `${sign}${chgPct.toFixed(2)}%` : '';
                    const priceText = latestPrice !== null ? `$${latestPrice.toFixed(2)} ` : '';
                    changeHTML = (priceText || pctText)
                        ? `<span class="ticker-price-change ${cls}">${priceText}${pctText}</span>`
                        : '';
                }
                const noData = !changeHTML;
                return `<button type="button" class="news-pill news-pill--ticker-price${noData ? ' news-pill--no-data' : ''}" data-symbol="${sym}" style="cursor:pointer;">
                    <span class="ticker-price-symbol">${sym}</span>${changeHTML}
                </button>`;
            }).filter(Boolean).join('');

            const priceCardHTML = memberPills
                ? `<div class="detail-section">
                    <h4 class="detail-section-title">${name}</h4>
                    <div class="news-graph-news-list news-graph-news-list--inline">${memberPills}</div>
                   </div>`
                : '';

            const summaryHTML = hasSummary
                ? `<div class="detail-section">
                    <h4 class="detail-section-title">Summary</h4>
                    <div class="detail-summary-card">${description.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div>
                </div>`
                : '';

            const relTopics = this._pendingRelatedTopics;
            this._pendingRelatedTopics = null;
            let relatedTopicsHTML = '';
            if (relTopics && relTopics.entries && relTopics.entries.length > 0) {
                const pillsHTML = relTopics.entries.slice(0, 6).map(({ item, isTicker, rel }) => {
                    const relBadge = rel ? `<span class="rel-badge">${rel}</span>` : '';
                    if (isTicker) {
                        const sym = item.symbol || item.id;
                        const itemName = item.name || '';
                        let title = itemName ? `${sym} - ${itemName}` : sym;
                        title = title.replace(/</g,'&lt;').replace(/>/g,'&gt;');
                        return `<button type="button" data-ticker-id="${item.id}" class="news-pill" style="cursor:pointer; text-align:left;">${relBadge}${title}</button>`;
                    } else {
                        const title = (item.short_label || item.title || item.label || item.id).replace(/</g,'&lt;').replace(/>/g,'&gt;');
                        return `<button type="button" data-narrative-id="${item.id}" class="news-pill" style="cursor:pointer; text-align:left;">${relBadge}${title}</button>`;
                    }
                }).join('');
                relatedTopicsHTML = `<div class="detail-section">
                    <h4 class="detail-section-title">Related Topics</h4>
                    <div class="news-graph-news-list">${pillsHTML}</div>
                </div>`;
            }

            detailContent.innerHTML = `
                ${priceCardHTML}
                ${summaryHTML}
                ${relatedTopicsHTML}
            `;

            detailContent.querySelectorAll('.news-pill--ticker-price[data-symbol]').forEach(pill => {
                const sym = pill.getAttribute('data-symbol');
                if (sym) pill.addEventListener('click', () => {
                    this._detailBackFn = () => this.openTickerDetail(ticker, data);
                    this.openTickerFromPill(sym);
                });
            });

            if (relTopics) {
                detailContent.querySelectorAll('.news-pill[data-narrative-id]').forEach(btn => {
                    const nid = btn.getAttribute('data-narrative-id');
                    const n = (relTopics.narrativeMap || {})[nid];
                    if (n) btn.addEventListener('click', () => {
                        const d = relTopics.data || this.lastNarrativeData;
                        if (typeof _buildRelatedTopicsData === 'function') {
                            this._pendingRelatedTopics = _buildRelatedTopicsData(n, d);
                        }
                        this.openNarrativeDetail(n);
                    });
                });
                detailContent.querySelectorAll('.news-pill[data-ticker-id]').forEach(btn => {
                    const tid = btn.getAttribute('data-ticker-id');
                    const t = (relTopics.tickerMap || {})[tid];
                    if (t) btn.addEventListener('click', () => {
                        const d = relTopics.data || this.lastNarrativeData;
                        if (typeof _buildRelatedTopicsData === 'function') {
                            this._pendingRelatedTopics = _buildRelatedTopicsData(t, d);
                        }
                        this.openTickerDetail(t, d);
                    });
                });
            }
        }

        newsMode.classList.add('narrative-mode');
        leftNewsBlock.classList.add('news-open');
    },

    openTickerFromPill: async function(symbol) {
        if (!this.container) return;
        const normalizedSymbol = String(symbol || '').toUpperCase();

        if (window._newsGraphInstance && typeof window._newsGraphInstance.selectNodeById === 'function') {
            window._newsGraphInstance.selectNodeById(normalizedSymbol, false);
        }

        if (document.body.classList.contains('news-graph-active')) {
            const data = this.lastNarrativeData;
            if (data) {
                const tickerNode = (data.tickers || []).find(t =>
                    String(t.symbol || '').toUpperCase() === normalizedSymbol ||
                    (t.grouped_tickers || []).some(s => String(s || '').toUpperCase() === normalizedSymbol)
                );
                if (tickerNode) {
                    if (typeof _buildRelatedTopicsData === 'function') {
                        this._pendingRelatedTopics = _buildRelatedTopicsData(tickerNode, data);
                    }
                    await this.openTickerDetail(tickerNode, data);
                    return;
                }
            }
            return;
        }

        if (window.selectTickerFromNews) {
            try {
                await window.selectTickerFromNews(normalizedSymbol);
            } catch (e) {
                console.error('[ticker-news] Error in selectTickerFromNews:', e);
            }
            return;
        }

        try {
            if (window.enterSearchMode) {
                window.enterSearchMode({ ticker: normalizedSymbol });
            }
        } catch (e) {
            console.error('[ticker-news] Error triggering search mode:', e);
        }

        this._detailBackFn = null;
        this.currentMode = 'ticker-news';
        this.data.ticker = normalizedSymbol;
        this.container.classList.remove('news-open');
        const newsMode = this.container.querySelector('.news-mode');
        if (newsMode) newsMode.classList.remove('narrative-mode');
        await this.renderTickerNews(normalizedSymbol);
    },

    _attachCardTooltip: function(card, text, sharedTooltip) {
        card.addEventListener('mouseenter', () => {
            sharedTooltip.textContent = text;
            sharedTooltip.style.display = 'block';
            const r = card.getBoundingClientRect();
            const top = r.bottom + 8;
            sharedTooltip.style.top = top + 'px';
            sharedTooltip.style.left = (r.left + 12) + 'px';
            sharedTooltip.style.width = (r.width - 24) + 'px';
        });
        card.addEventListener('mouseleave', () => {
            sharedTooltip.style.display = 'none';
        });
    },

    _initSourceTooltip: function() {
        let el = document.getElementById('narrative-source-tooltip');
        if (!el) {
            el = document.createElement('div');
            el.id = 'narrative-source-tooltip';
            document.body.appendChild(el);
        }
        return el;
    },

    syncFiltersUI: function(filter) {
        if (!this.container) return;
        const filterMap = { 'general': 'market-summary', 'watchlist': 'watchlist-news' };
        const dataFilter = filterMap[filter] || filter;
        this.container.querySelectorAll('.news-view-toggles .view-btn').forEach(btn => {
            btn.classList.remove('active');
        });
        const activeBtn = this.container.querySelector(`.view-btn[data-filter="${dataFilter}"]`);
        if (activeBtn) activeBtn.classList.add('active');
    },

    setTicker: function(ticker) {
        const oldData = { ticker: this.data.ticker, position: this.data.position };
        this.data.ticker = ticker;
        this.update(oldData);
    },

    update: async function (oldData) {
        if (!this.apiManager || !this.apiManager.isInitialized) {
            return;
        }
        
        const isForceUpdate = (oldData.ticker === 'FORCE_UPDATE');
        
        if (oldData.ticker !== this.data.ticker || oldData.position !== this.data.position || isForceUpdate) {

            const newTicker = (this.data.ticker || '').toUpperCase();
            if (newTicker !== 'BUSINESS') {
                this.currentMode = 'ticker-news';
                this.renderTickerNews(this.data.ticker);
                return;
            }

            if (this.currentMode === 'market-summary') {
                this.renderMarketSummary(isForceUpdate);
            } else if (this.currentMode === 'business-headlines') {
                this.renderBusinessHeadlines(isForceUpdate);
            } else if (this.currentMode === 'trending-stock') {
                this.renderTrendingStock(isForceUpdate);
            } else if (this.currentMode === 'watchlist-news') {
                this.renderWatchlistNews(isForceUpdate);
            }
        }
    },

    renderTickerNews: async function(ticker) {
        if (!this.container) return;
        const newsListEl = this.container.querySelector('.news-list');
        const titleEl = this.container.querySelector('.preview-mode .title h3');

        this.syncFiltersUI('none');

        const symbol = ticker.includes(':') ? ticker.split(':')[1] : ticker;
        if (window._newsGraphInstance && typeof window._newsGraphInstance.selectNodeById === 'function') {
            window._newsGraphInstance.selectNodeById(symbol, false);
        }
        if (titleEl) titleEl.textContent = symbol + ' News';
        if (newsListEl) newsListEl.innerHTML = '<p class="news-loading">Loading...</p>';

        let articles;
        try {
            articles = await this.apiManager.fetchStockNews(ticker);
        } catch(e) {
            if (newsListEl) newsListEl.innerHTML = '<p class="news-loading">Failed to load news.</p>';
            return;
        }

        if (!newsListEl) return;
        if (!articles || articles.length === 0) {
            newsListEl.innerHTML = '<p class="news-loading">No articles found.</p>';
            return;
        }

        articles.sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate));

        const priceMap = NewsProxyAPIManager.buildTickerPriceMap(this.lastNarrativeData);
        const getPriceEntry = (sym) => priceMap.get(String(sym || '').toUpperCase()) ?? null;
        const sharedTooltip = this._initSourceTooltip();
        newsListEl.innerHTML = '';

        const mainEntry = getPriceEntry(symbol);
        const tickerCard = document.createElement('div');
        tickerCard.className = 'ticker-price-card';
        if (this.isPreIpoSymbol(symbol)) {
            tickerCard.innerHTML = `
                <div class="ticker-price-top">
                    <span class="ticker-price-name">${symbol.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</span>
                    <span class="ticker-price-value"></span>
                </div>
                <div class="ticker-price-bottom">
                    <span class="ticker-price-symbol">${symbol}</span>
                    <span class="ticker-price-change neutral"><span class="pre-ipo-tag" style="color: #888; font-size: 11px; font-weight: bold;">Pre-IPO</span></span>
                </div>
            `;
        } else {
            const latestPrice = mainEntry?.price ?? null;
            const chgPct = mainEntry?.changePct ?? null;
            const hasPct = chgPct !== null;
            const cls = hasPct ? (chgPct >= 0 ? 'positive' : 'negative') : 'neutral';
            const sign = hasPct && chgPct >= 0 ? '+' : '';
            const pctText = hasPct ? `${sign}${chgPct.toFixed(2)}%` : 'N/A';
            tickerCard.innerHTML = `
                <div class="ticker-price-top">
                    <span class="ticker-price-name">${symbol.replace(/</g, '&lt;').replace(/>/g, '&gt;')}</span>
                    <span class="ticker-price-value">${Number.isFinite(latestPrice) ? '$' + latestPrice.toFixed(2) : ''}</span>
                </div>
                <div class="ticker-price-bottom">
                    <span class="ticker-price-symbol">${symbol}</span>
                    <span class="ticker-price-change ${cls}">${pctText}</span>
                </div>
            `;
        }
        newsListEl.appendChild(tickerCard);

        articles.forEach(article => {
            let dateStr = '';
            if (article.publishedDate) {
                try {
                    const d = new Date(article.publishedDate);
                    dateStr = d.toLocaleString('en-US', { month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' });
                } catch(e) {}
            }

            const tickerPillsHTML = (article.tickers || []).slice(0, 3).map(sym => {
                if (this.isPreIpoSymbol(sym)) {
                    return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}<span class="pre-ipo-tag" style="color: #888; font-size: 11px; font-weight: bold; margin-left: 4px;">Pre-IPO</span></span>`;
                }
                const entry = getPriceEntry(sym);
                const chgPct = entry?.changePct ?? null;
                if (chgPct === null) return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}</span>`;
                const cls = chgPct >= 0 ? 'positive' : 'negative';
                const sign = chgPct >= 0 ? '+' : '';
                return `<span class="asset-pill asset-pill--clickable" data-symbol="${sym}">${sym}<span class="asset-price-change ${cls}">${sign}${chgPct.toFixed(2)}%</span></span>`;
            }).join('');

            const card = document.createElement('div');
            card.className = 'watchlist-card';
            card.innerHTML = `
                <div class="source-card-header">
                    <span class="source-name">${article.publisher || 'Unknown'}</span>
                    <span class="source-date">${dateStr}</span>
                </div>
                <div class="watchlist-card-title">${(article.title || '').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</div>
                <div class="watchlist-card-footer">
                    <div class="watchlist-card-tickers">${tickerPillsHTML}</div>
                    <a class="source-open-btn" href="${(article.url || '#').replace(/"/g,'%22')}" target="_blank" rel="noopener noreferrer">Open ↗</a>
                </div>
            `;

            card.querySelectorAll('.asset-pill--clickable[data-symbol]').forEach(pill => {
                pill.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this._detailBackFn = () => this.renderTickerNews(ticker);
                    this.openTickerFromPill(pill.dataset.symbol);
                });
            });

            const tooltipText = (article.description || '').trim();
            if (tooltipText) this._attachCardTooltip(card, tooltipText, sharedTooltip);

            newsListEl.appendChild(card);
        });
    },

    async onWatchlistDataLoaded() {
        const State = window.WatchlistApp?.State;
        if (State?.currentWatchlistId) {
            this.activeWatchlistId = State.currentWatchlistId;
        }

        const watchlistBtn = this.container ? this.container.querySelector('.view-btn[data-filter="watchlist-news"]') : null;
        const isWatchlistFilterActive = watchlistBtn && watchlistBtn.classList.contains('active');

        if (isWatchlistFilterActive && this.data.ticker === 'BUSINESS') {
            if (__LOG_INFO__) AppLog.info('onWatchlistDataLoaded: Triggering reload for watchlist overview news');
            this.update({ticker: 'FORCE_UPDATE'});
        }
    },

    onAuthSessionChanged: function(e) {
        const session = e.detail?.session;
        const isLoggedIn = !!(session?.user && !session.user.is_anonymous);
        this.updateWatchlistBtnState(isLoggedIn);

        if (!isLoggedIn) {
            const watchlistBtn = this.container ? this.container.querySelector('.view-btn[data-filter="watchlist-news"]') : null;
            const isWatchlistFilterActive = watchlistBtn && watchlistBtn.classList.contains('active');
            
            if (isWatchlistFilterActive) {
                this.syncFiltersUI('general');
                this.data.ticker = 'BUSINESS';
                this.update({ticker: 'FORCE_UPDATE'});
            }
        }
    },

    onWatchlistAuthChanged: function(e) {
        const reason = e.detail?.reason;

        if (reason === 'signed_in') {
            this.updateWatchlistBtnState(true);
        } else if (reason === 'signed_out' || reason === 'anonymous' || reason === 'consent_revoked') {
            this.updateWatchlistBtnState(false);
            const watchlistBtn = this.container ? this.container.querySelector('.view-btn[data-filter="watchlist-news"]') : null;
            const isWatchlistActive = watchlistBtn && watchlistBtn.classList.contains('active');
            if (isWatchlistActive) {
                this.currentMode = 'market-summary';
                this.syncFiltersUI('market-summary');
                this.renderMarketSummary();
            }
        }
    },

    remove: function() {
        if (this.newsScheduler) {
            this.newsScheduler.stop();
        }
        if (this.onWatchlistDataLoaded) document.body.removeEventListener('watchlist-data-loaded', this.onWatchlistDataLoaded);
        if (this.onAuthSessionChanged) document.removeEventListener('auth:session-changed', this.onAuthSessionChanged);
        if (this.onWatchlistAuthChanged) document.removeEventListener('watchlist:auth-changed', this.onWatchlistAuthChanged);
        if (this.observer) this.observer.disconnect();
    }
};

document.addEventListener('DOMContentLoaded', function() {
    const instance = Object.create(window.TickerNewsComponent);
    instance.data = {
        ticker: 'BUSINESS',
        containerSelector: '#left-container'
    };
    instance.init();
    window._tickerNewsInstance = instance;
});
